import { Pipe, PipeTransform } from "@angular/core";

/**
 * Filtro que limpa quebra de linha (\r).
 */
@Pipe({
    name: "cleanLineBreak"
})
export class CleanLineBreakPipe implements PipeTransform {

    transform(value: string): string {
        if (!value) {
            return value;
        }

        return value.replace(/\r|\\r/g, "");
    }
}
